export default () => ({
  item: {},
  items: [],
  pagination: [],
})
